import { getConfig } from "../../../config/runtimeConfig";
import { ACCESS_TOKEN } from "../../Contants";
import {
  resolveExplicitDialectByLanguage,
  resolveResourceIdByLanguage,
  resolveSpeakerByLanguage,
  toVolcSpeechRate,
} from "../textToSpeechUtil";

const DEFAULT_ENDPOINT = "https://tts.nblib.com/tts/synthesize";

const FORMAT_MIME = {
  mp3: "audio/mpeg",
  wav: "audio/wav",
  pcm: "audio/pcm",
  ogg_opus: "audio/ogg",
};

function normalizeEndpoint(endpoint) {
  return (endpoint || DEFAULT_ENDPOINT).replace(/\/+$/, "");
}

function base64ToAudioBlob(base64, format = "mp3") {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], {
    type: FORMAT_MIME[format] || "audio/mpeg",
  });
}

function resolveAuthContext() {
  const accessToken = localStorage.getItem(ACCESS_TOKEN);
  if (!accessToken) {
    throw new Error("請先登入後再使用聽書");
  }

  let orgId = "";
  try {
    orgId = getConfig().CLIENT_ID || "";
  } catch {
    orgId = "";
  }
  if (!orgId) {
    throw new Error("聽書設定缺少機構識別（CLIENT_ID）");
  }

  return { accessToken, orgId };
}

/**
 * POST {endpoint} → audio Blob (API Gateway + Volcengine TTS)
 */
export async function synthesizeSpeech(
  { text, language, rate, endpoint },
  signal
) {
  const { accessToken, orgId } = resolveAuthContext();
  const speaker = resolveSpeakerByLanguage(language);
  const resourceId = resolveResourceIdByLanguage(language);
  const explicitDialect = resolveExplicitDialectByLanguage(language);
  const speechRate = toVolcSpeechRate(rate);

  const response = await fetch(normalizeEndpoint(endpoint), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
      "X-Org-Id": orgId,
    },
    body: JSON.stringify({
      text,
      speaker,
      resource_id: resourceId,
      speech_rate: speechRate,
      ...(explicitDialect ? { explicit_dialect: explicitDialect } : {}),
    }),
    signal,
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      throw new Error(
        data.message || data.error || "聽書未授權，請重新登入"
      );
    }
    throw new Error(data.error || `TTS synthesize failed: ${response.status}`);
  }

  const audioBase64 = data.audio_base64 || data.audio;
  if (!audioBase64) {
    throw new Error("TTS synthesize response missing audio");
  }

  return base64ToAudioBlob(audioBase64, data.format || "mp3");
}

export { DEFAULT_ENDPOINT, normalizeEndpoint };
